import AppCatalog from "../../services/App/AppCatalog.js";
import AppModule from "../../services/App/AppModule.js";

export default {
  DispatchID: {
    Label: AppModule.Item.FullName,
    ColumnLabel: AppCatalog.Field.Name.Label,
    ExportLabel: AppCatalog.Field.Name.Label,
    PrintLabel: AppCatalog.Field.Name.Label,
    Type: AppCatalog.Field.ID.Type,
    Required: true,
    RelatedValue: "DispatchName",
    RelatedModule: AppModule.Item,
    RelatedIsActive: "DispatchIsActive",
    Valid: true
  },
  Qty: {
    Label: AppCatalog.Field.Qty.Label,
    Type: AppCatalog.Field.Qty.Type,
    MinValue: AppCatalog.Field.Qty.MinValue,
    MaxValue: "ReceiveItemQty",
    MaxLength: AppCatalog.Field.Qty.MaxLength,
    Required: true
  },
  BuyPrice: {
    Label: AppCatalog.Field.BuyPrice.Label,
    Type: AppCatalog.Field.BuyPrice.Type,
    Output: AppCatalog.Field.BuyPrice.Output,
    ReadOnly: true
  },
  SubTotal: {
    Label: AppCatalog.Field.SubTotal.Label,
    Type: AppCatalog.Field.SubTotal.Type,
    Output: AppCatalog.Field.SubTotal.Output,
    ReadOnly: AppCatalog.Field.SubTotal.ReadOnly
  },
  TotalQty: {
    Label: AppCatalog.Field.TotalQty.Label,
    Type: AppCatalog.Field.TotalQty.Type,
    ReadOnly: AppCatalog.Field.TotalQty.ReadOnly
  },

  // support
  Packaging: {
    Label: AppModule.ItemPackaging.FullName,
    Type: AppCatalog.Field.Name.Type,
    ReadOnly: true
  },
  SKU: {
    Label: AppCatalog.Field.SKU.Label,
    Type: AppCatalog.Field.SKU.Type,
    ReadOnly: true
  },
  ReceiveItemQty: {
    Label: AppCatalog.Field.Qty.Label + " Beli",
    Type: AppCatalog.Field.Qty.Type,
    ReadOnly: true
  }
}